<template>
  <div
    class="custom-select"
    :class="{ compactRoot: compact }"
    :key="key"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div
      class="selected"
      :class="{ open: open, compact: compact }"
      @click="open = !open"
    >
      <span class="flag" aria-hidden="true">{{
        getLanguageFlag(selected)
      }}</span>
      <span class="label" dir="auto">{{ getLanguageLabel(selected) }}</span>
    </div>
    <div class="items" :class="{ selectHide: !open, compactPanel: compact }">
      <div
        class="item"
        v-for="(option, i) of filterOptions"
        :key="i"
        @click="
          ;(selected = option),
            (open = false),
            $emit('input', option),
            changeLanguage(option)
        "
      >
        <span class="flag" aria-hidden="true">{{
          getLanguageFlag(option)
        }}</span>
        <span class="label" dir="auto">{{ getLanguageLabel(option) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import setLang from '@/scripts/root/setLang'
import { languageFlags } from '@/data/navigation/languageFlags'

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selected:
        this.$store.getters.getAppLanguage ||
        (this.options.length > 0 ? this.options[0] : null),
      filterOptions: this.options,
      open: false,
      key: 0,
    }
  },
  methods: {
    getLanguageLabel(lang) {
      return String(this.$t(`navigation.navbar.languages.${lang}`))
    },
    getLanguageFlag(lang) {
      return languageFlags[lang] || '🌐'
    },
    changeLanguage(lang) {
      if (!this.options.includes(lang)) return
      setLang(lang)
      this.filterOptions = this.options.filter((option) => option !== lang)
      this.$forceUpdate()
    },
  },
  mounted() {
    const initial =
      this.options.find((locale) => locale === this.$i18n.locale) ||
      this.selected
    if (initial) {
      this.selected = initial
      this.changeLanguage(initial)
      this.$emit('input', this.selected)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.custom-select {
  position: relative;
  margin: 10px auto;
  width: fit-content;
  min-width: 120px;
  max-width: 75vw;
  text-align: left;
  outline: none;
  height: 45px;
  line-height: 45px;
  font-size: 110%;
  font-weight: 500;
  z-index: 2;
}

.selected {
  background-color: #f7f7f7;
  border: 1px solid theme(gray);
  border-radius: 8px;
  color: theme(black);
  padding-left: 10px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 28px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.selected.open {
  border: 1px solid theme(main);
  border-bottom: none;
  border-radius: 8px 8px 0px 0px;
}

.selected:after {
  position: absolute;
  content: '';
  top: 22px;
  right: 10px;
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-color: theme(black) transparent transparent transparent;
}

.items {
  color: theme(black);
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;
  border-right: 1px solid theme(main);
  border-left: 1px solid theme(main);
  border-bottom: 1px solid theme(main);
  position: absolute;
  background-color: #ffffff;
  left: 0;
  right: 0;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.item {
  color: theme(black);
  padding-left: 8px;
  padding-right: 28px;
  cursor: pointer;
  user-select: none;
  transition: 0.2s all;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.item:hover {
  background-color: theme(gray);
}

.selectHide {
  display: none;
}

.compactPanel {
  top: calc(100% + 10px);
  min-width: 180px;
  left: auto;
  right: 0;
  border: 1px solid theme(main);
  border-radius: 16px;
}

.flag {
  width: 28px;
  font-size: 22px;
  line-height: 1;
  text-align: center;
  margin-right: 2px;
}

.compactRoot {
  min-width: 64px;
  max-width: 64px;
  margin: 0;
}

.selected.compact {
  box-sizing: border-box;
  width: 64px;
  justify-content: center;
  padding: 0;
  border-radius: 14px;
}

.selected.compact::after {
  display: none;
}

.selected.compact.open {
  border-bottom: 1px solid theme(main);
  border-radius: 14px;
}

.selected.compact .label {
  display: none;
}

.selected.compact .flag {
  margin-right: 0;
  padding-right: 0;
}

@media (max-width: 820px) {
  .compactRoot {
    min-width: 58px;
    max-width: 58px;
  }

  .selected.compact {
    width: 58px;
  }
}
</style>
